export default __webpack_public_path__ + "static/media/group-141.054ed6a6.png";